export const LOGIN_FORM_CHANGED= "LOGIN_FORM_CHANGED";
export const LOGIN_FORM_CLEAR_ERROR= "LOGIN_FORM_CLEAR_ERROR";
export const LOG_OUT= "LOG_OUT";
export const IS_LOADING="IS_LOADING";
  